// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-country-code-input {
  display: flex;
  width: 100%;
  gap: 8px;
}

.phone-input-new {
  flex: 1;
}

/* Hide spin-button for Chrome, Safari, Edge, Opera */
.phone-input-new input::-webkit-outer-spin-button,
.phone-input-new input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide spin-button for Firefox */
.phone-input-new input[type="number"] {
  -moz-appearance: textfield;
}

`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CartAddCustomer/NewCountryCodeInput.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA,qDAAqD;AACrD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;AAC5B","sourcesContent":[".new-country-code-input {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n}\n\n.phone-input-new {\n  flex: 1;\n}\n\n/* Hide spin-button for Chrome, Safari, Edge, Opera */\n.phone-input-new input::-webkit-outer-spin-button,\n.phone-input-new input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide spin-button for Firefox */\n.phone-input-new input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
